<nb-card>
  <nb-card-header>
    <span>
      {{ "Environmental profile" | translate }} -
      @if (assetType) {
        {{ assetType.name }}
      }
    </span>

  </nb-card-header>
  <nb-card-body>
    <div class="container-fluid">
      <nb-tabset fullWidth>
        @for (profile of mappedEnvironmentalProfiles; track profile) {
          <nb-tab [tabTitle]="profile.tabName">
            <table class="investments-table table table-hover">
              <tbody>
                <tr>
                  <td>{{ "Product name" | translate }}</td>
                  <td>{{ profile.product_name || '-' }}</td>
                </tr>
                <tr>
                  <td>{{ "Update date" | translate }}</td>
                  <td>{{ profile.modified_on | date:'longDate' }}</td>
                </tr>
                <tr>
                  <td>{{ "Reporting organization" | translate }}</td>
                  <td>{{ profile.reporting_organization || '-' }}</td>
                </tr>
                <tr>
                  <td>{{ "Source" | translate }}</td>
                  @if (profile.source) {
                    <td>
                      <fa-icon icon="up-right-from-square"></fa-icon>&nbsp;<a [href]="profile.source" target="_blank">{{ profile.source }}</a>
                    </td>
                  }
                  @if (!profile.source) {
                    <td>-</td>
                  }
                </tr>
                <tr>
                  <td>{{ "Version" | translate }}</td>
                  <td>{{ profile.version || '-' }}</td>
                </tr>
                <tr>
                  <td>{{ "End of validity date" | translate }}</td>
                  <td>{{ profile.end_of_validity | date:'longDate' }}</td>
                </tr>
                <tr>
                  <td>{{ "Production emissions" | translate }}</td>
                  @if (profile.production_emissions) {
                    <td>{{ profile.production_emissions | thousandsSeparator }} {{ "pages.energy.kg_CO2" | translate }}</td>
                  }
                  @if (!profile.production_emissions) {
                    <td>-</td>
                  }
                </tr>
                <tr>
                  <td>{{ "Transport / installation emissions" | translate }}</td>
                  @if (profile.transport_emissions) {
                    <td>{{ profile.transport_emissions | thousandsSeparator }} {{ "pages.energy.kg_CO2" | translate }}</td>
                  }
                  @if (!profile.transport_emissions) {
                    <td>-</td>
                  }
                </tr>
                <tr>
                  <td>{{ "Operational emissions" | translate }}</td>
                  @if (profile.life_emissions) {
                    <td>{{ profile.life_emissions | thousandsSeparator }} {{ "pages.energy.kg_CO2" | translate }}</td>
                  }
                  @if (!profile.life_emissions) {
                    <td>-</td>
                  }
                </tr>
                <tr>
                  <td>{{ "Maintenance / repair emissions" | translate }}</td>
                  @if (profile.maintenance_emissions) {
                    <td>{{ profile.maintenance_emissions | thousandsSeparator }} {{ "pages.energy.kg_CO2" | translate }}</td>
                  }
                  @if (!profile.maintenance_emissions) {
                    <td>-</td>
                  }
                </tr>
                <tr>
                  <td>{{ "End of life emissions" | translate }}</td>
                  @if (profile.end_of_life_emissions) {
                    <td>{{ profile.end_of_life_emissions | thousandsSeparator }} {{ "pages.energy.kg_CO2" | translate }}</td>
                  }
                  @if (!profile.end_of_life_emissions) {
                    <td>-</td>
                  }
                </tr>
                <tr>
                  <td>{{ "Total" | translate }}</td>
                  @if (profile.total_emissions) {
                    <td>{{ profile.total_emissions | thousandsSeparator }} {{ "pages.energy.kg_CO2" | translate }}</td>
                  }
                  @if (!profile.total_emissions) {
                    <td>-</td>
                  }
                </tr>
                <tr>
                  <td>{{ "Of which embodied emissions" | translate }}</td>
                  @if (profile.embodied_emissions) {
                    <td>
                      {{ profile.embodied_emissions | thousandsSeparator }} {{ "pages.energy.kg_CO2" | translate }}@if (profile.yearly_embodied_emissions) {
                      ,
                      {{ "ie {emissions} kg CO² by year of life" | translate:{emissions: profile.yearly_embodied_emissions} }}
                    }
                  </td>
                }
                @if (!profile.embodied_emissions) {
                  <td>-</td>
                }
              </tr>
              <tr>
                <td>{{ "Of which operational emissions" | translate }}</td>
                @if (profile.operational_emissions) {
                  <td>{{ profile.operational_emissions | thousandsSeparator }} {{ "pages.energy.kg_CO2" | translate }}</td>
                }
                @if (!profile.operational_emissions) {
                  <td>-</td>
                }
              </tr>
            </tbody>
          </table>
        </nb-tab>
      }
    </nb-tabset>
  </div>
</nb-card-body>
</nb-card>
